import { API_DATA_FORMAT, API_STATUS } from 'core-lib/constants/network';
import { ApiDataFormat } from 'core-lib/types/Network';
import ip from 'icepick';
import { VehicleDetail } from 'chariot/types';
import {
  GET_CHARIOT_FAILURE,
  GET_CHARIOT_REQUEST,
  GET_CHARIOT_SUCCESS,
} from "./type"

const initialState: {
  vehicles: VehicleDetail[];
  getVehicle: ApiDataFormat;
} = ip.freeze({
  vehicles: [],
  getVehicle: { ...API_DATA_FORMAT },
});

export function vehicleReducer(state = initialState, action) {
  switch (action.type) {
    case GET_CHARIOT_REQUEST: {
      state = ip.setIn(
        state,
        ['getVehicle', 'apiStatus'],
        API_STATUS.in_progress
      );
      state = ip.setIn(state, ['getVehicle', 'apiError'], null);
      return state;
    }

    case GET_CHARIOT_SUCCESS: {
      state = ip.setIn(state, ['getVehicle', 'apiStatus'], API_STATUS.success);
      state = ip.setIn(state, ['getVehicle', 'apiError'], null);
      state = ip.setIn(state, ['vehicles'], action.payload);
      return state;
    }

    case GET_CHARIOT_FAILURE: {
      state = ip.setIn(state, ['getVehicle', 'apiStatus'], API_STATUS.failure);
      state = ip.setIn(state, ['getVehicle', 'apiError'], action.payload);
      return state;
    }

    default:
      return state;
  }
}

export default vehicleReducer;
